module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAwBAMAAABeexFrAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURQJYodcCEv39/f3x8/b19dkCEghUlcUIFuEAEv///wBap4x2DycAAAAIdFJOU+Xl9fPl5d3d5fjkSQAAAEFJREFUOMtjKBQkBMQZJDoIgcZRNSNUjbMxIWDC4DSTEFBh8CSoZsqomiGmxkmJEFBh4FpFCCwYVTNC1SQwEAJsAAcXkXdWBupOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/netherlands.png
// module id = sxJE
// module chunks = 34